import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OfferRequest } from '@models/offer/offerRequest.model';
import { environment } from '../../../environments/environment';
import { RehireRequest } from '@app/models/rehireRequest.model';
import { Message } from '@app/models/conversation/message.model';

@Injectable()
export class RehireRequestService {
  private baseHref = `${environment.apiUrl}/conversations`;

  constructor(private http: HttpClient) {}

  createRehireRequest(rehireRequestData: RehireRequest): Observable<Message[]> {
    const url = `${this.baseHref}/book_again`;
    return this.http.post<Message[]>(url, rehireRequestData);
  }
}
